export default {
  apiKey: "AIzaSyCsTu6-_DA2G0WWHgjfR8Z_j8rlSxOf-5c",
  authDomain: "genco-38c28.firebaseapp.com",
  databaseURL: "https://genco-38c28.firebaseio.com",
  projectId: "genco-38c28",
  storageBucket: "genco-38c28.appspot.com",
  messagingSenderId: "634704782818",
  appId: "1:634704782818:web:7e2fb9cd4c27e86ada85bb",
  measurementId: "G-5MBRL27J5C",
};
